import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateUserDocument } from './update.generated';

export const useUpdateUser = (options: ApiOptions<typeof UpdateUserDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(UpdateUserDocument, {
    ...useNotifications(UpdateUserDocument, {
      failure: (error) => error.message,
      success: (data) =>
        data.updateUser?.user?.name != null
          ? t('api.users.update_success_with_name', { name: data.updateUser.user.name })
          : t('api.users.update_success'),
    }),

    ...options,
  });
};
